import { Reveal } from "../components/Reveal";
import { Soon } from "../components/Soon";
import {
  SCHEDULE_COMING_SOON,
  comingSoon,
  schedule,
  venue,
} from "../content/wedding";

export function Schedule() {
  return (
    <section class="section section--forest">
      <div class="shell">
        <Reveal class="section-head">
          <span class="eyebrow">The Schedule</span>
          <h2>
            {venue.name}
            <br />
            {venue.place}
          </h2>
        </Reveal>

        {SCHEDULE_COMING_SOON ? (
          <Soon>{comingSoon.note.schedule}</Soon>
        ) : (
          <div class="schedule__list">
            {schedule.map((item, i) => (
              <Reveal
                as="article"
                class="schedule__item"
                key={item.title}
                delay={i * 70}
              >
                <p class="schedule__time">{item.time}</p>
                <div class="schedule__body">
                  <h3 class="schedule__title">{item.title}</h3>
                  <p class="schedule__detail">{item.detail}</p>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
